import LiveMonitoringMap from './LiveMonitoringMap';

export default LiveMonitoringMap;
